import { useCallback, useMemo } from 'react';
import { useUsers } from './useUsers';
import {
  buildUserColorIndex,
  resolveUserColor,
} from '../utils/userColorIndex';
import type { AvatarColour } from '../styles/avatarPalette';

/**
 * Resolve avatar colours for any user by id and/or name, backed by the cached
 * users list. Returns `colorFor`, stable for the lifetime of the loaded list, so
 * the same user renders the same colour wherever their avatar appears.
 */
export function useUserColors() {
  const { users: userList } = useUsers();
  const index = useMemo(() => buildUserColorIndex(userList), [userList]);
  const colorFor = useCallback(
    (ref: { id?: string | null; name?: string | null }): AvatarColour =>
      resolveUserColor(index, ref),
    [index],
  );
  return { colorFor };
}
